import { render, staticRenderFns } from "./PaginaImportaOneriLavoro.vue?vue&type=template&id=297e07b4"
import script from "./PaginaImportaOneriLavoro.vue?vue&type=script&lang=js"
export * from "./PaginaImportaOneriLavoro.vue?vue&type=script&lang=js"
import style0 from "./PaginaImportaOneriLavoro.vue?vue&type=style&index=0&id=297e07b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports